var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: { variant: "info" },
                      on: {
                        click: function($event) {
                          _vm.displayStatus = false
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "message.booking.switch_professional_modal.confirm_button"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.displayStatus,
        callback: function($$v) {
          _vm.displayStatus = $$v
        },
        expression: "displayStatus"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("message.booking.switch_professional_modal.title")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "text-center" }, [
        _c("div", [
          _c("img", {
            attrs: { src: "/static/img/ic_announcement.svg", width: "104" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-3" }, [
          _c("h3", [
            _vm._v(
              _vm._s(
                _vm.$t("message.booking.switch_professional_modal.subtitle1")
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "mb-2" }, [
          _c("img", {
            attrs: { src: "/static/img/ic_switch_professional_issue01.svg" }
          }),
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("message.booking.switch_professional_modal.issue1")
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-2" }, [
          _c("img", {
            attrs: { src: "/static/img/ic_switch_professional_issue02.svg" }
          }),
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("message.booking.switch_professional_modal.issue2")
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-2" }, [
          _c("img", {
            attrs: { src: "/static/img/ic_switch_professional_issue03.svg" }
          }),
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("message.booking.switch_professional_modal.issue3")
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-2" }, [
          _c("img", {
            attrs: { src: "/static/img/ic_switch_professional_issue04.svg" }
          }),
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("message.booking.switch_professional_modal.issue4")
              ) +
              "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "text-center" }, [
        _c("div", { staticClass: "my-3" }, [
          _c("h3", [
            _c("span", { staticClass: "text-info" }, [_vm._v("BeNeat")]),
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("message.booking.switch_professional_modal.subtitle2")
                )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "px-4 py-3 rounded bg-gray" }, [
          _c("div", { staticClass: "font-weight-light" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "message.booking.switch_professional_modal.subtitle2_content1"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-info font-weight-normal" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "message.booking.switch_professional_modal.subtitle2_content2"
                )
              )
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0859245e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0859245e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/SelectPreBookingProfessionalInfoModal.vue
// module id = 1742
// module chunks = 0